export const TEXT_POSITION = '-19.5rem';